import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  suppressScrollX: true               
};

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns'; 
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { AppRoutingModule } from './app.routing';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppSettings } from './app.settings';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';

import { TopInfoContentComponent } from './theme/components/top-info-content/top-info-content.component';
import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { AppOAuthStore } from 'src/app/models/AppOAuthSotarge';
import { DialogCatAC } from './shared/cat-autocomplete/catautocompleteAdd.component';
import { DialogConfirmacion } from './shared/dialogs/confirmacion/dialogConfirmacion.component';
import { DialogCatACContacto } from './shared/cat-autocomplete/catAutocompleteAddContacto.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ExportService } from './services/exportService.service';
import { ConfiguradorColumnas } from './services/configuradorColumnas.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './services/customMatPaginator.service';
import { GuardianService } from './services/Guardian.service'; // 2021-08-13 (aangeles)
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { DialogRegistroLlamada } from './pages/ModuloSocorros/Servicios/Controllers/Dialogs/dialogRegistroLlamada.component';
import { AuthLogInService } from './services/AuthLogIn.services';
//import { ScrollingModule } from '@angular/cdk/scrolling';


// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http,'./assets/i18n/');
// }

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,     
    //ScrollingModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    SharedModule,
    PipesModule,
    AppRoutingModule,
    HttpClientModule,
    FontAwesomeModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'  
    }),
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    TopInfoContentComponent,
    SidenavComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    MessagesComponent,
    UserMenuComponent,
    DialogCatAC,
    DialogCatACContacto,
    DialogConfirmacion,
    DialogRegistroLlamada
  ],
  entryComponents: [
    VerticalMenuComponent,
    DialogCatAC,
    DialogCatACContacto,
    DialogConfirmacion,
    DialogRegistroLlamada
  ],
  providers: [
    AppSettings,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: AppOAuthStore, useFactory: () => new AppOAuthStore('CECOM') },
    GuardianService,
    AuthLogInService,
    ExportService,//2021-08-25 (aaangeles)
    ConfiguradorColumnas,//2021-09-09 (aaangeles)
    { provide: AppOAuthStore, useFactory: () => new AppOAuthStore('CECOM') },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }, // 2021-09-11 (aaangeles)
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX'}
  ],
  bootstrap: [
    AppComponent
  ]
})

export class AppModule { }

